import { render, staticRenderFns } from "./storePendingOrder.vue?vue&type=template&id=a5513e1a&scoped=true&"
import script from "./storePendingOrder.vue?vue&type=script&lang=js&"
export * from "./storePendingOrder.vue?vue&type=script&lang=js&"
import style0 from "./storePendingOrder.vue?vue&type=style&index=0&id=a5513e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5513e1a",
  null
  
)

export default component.exports